import axios from 'axios';
import router from '@/router';
import Cookies from 'js-cookie';
import { auth } from '@/utilities/api';

import { VUE_APP_API_URL } from '@/utilities/constants.js';

axios.interceptors.request.use(
  function(request) {
    // window.navigator.userLanguage used to be compatible with Internet Explorer
    /*
    let prefLanguage =
      window.navigator.userLanguage || window.navigator.language;
    */

    // Adds "Accept-Language" header to each get request
    // let language = "it-IT";
    // if (localStorage.getItem("langOption") == "en") {
    //   language = "en-EN";
    // }

    // request.headers.get["Accept-Language"] = language;
    const listOfPublicViews = [
      '/view-projects',
      '/profile',
      '/showcase',
      '/invitation',
      '/terms-and-conditions',
      '/privacy-policy',
      '/signup',
      '/direct-registration',
      '/projects',
      '/creativities',
      '/itineraries',
      '/around-me',
      '/latest-members',
      '/latest-showcases',
      '/latest-itineraries',
      '/profile-showcases'
    ];

    const bearerToken = Cookies.get('bearerToken');
    const ksToken = Cookies.get('ksBearerToken');

    const publicMode =
      listOfPublicViews.some(route => {
        return window.location.href.includes(route);
      }) && !bearerToken;

    if (
      request.url !== VUE_APP_API_URL + '/auth/login' &&
      !request.url.includes('member-Ofs') &&
      !publicMode
    ) {
      request.headers['Authorization'] = ksToken || bearerToken;
    }
    return request;
  },
  function(err) {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  undefined,

  function(err) {
    //if error is not 401 && url is not to refresh token reject promise
    if (err.response.status !== 401 && err.config.url !== '/auth/refresh-token')
      return Promise.reject(err);

    //if error comes from refreh token endpoint remove cookies and storage redirect to login
    if (err.config.url === '/auth/refresh-token') {
      Cookies.remove('bearerToken');
      Cookies.remove('ksBearerToken');
      localStorage.removeItem('vuex');
      return new Promise(() => {
        router.push(`/login?authError=true`);
      });
    }

    const listOfPublicViews = [
      '/view-projects',
      '/profile',
      '/showcase',
      '/invitation',
      '/terms-and-conditions',
      '/privacy-policy',
      '/signup',
      '/direct-registration',
      '/projects',
      '/creativities',
      '/itineraries',
      '/around-me',
      '/login',
      '/latest-members',
      '/latest-showcases',
      '/latest-itineraries',
      '/profile-showcases'
    ];

    if (err && err.response) {
      const validPath = listOfPublicViews.some(route => {
        return window.location.href.includes(route);
      });

      //check is token is available
      const bearerToken = Cookies.get('bearerToken');
      const ksToken = Cookies.get('ksBearerToken');

      //if ksToken refresh ks token
      if (ksToken) {
        return auth.refresh(ksToken, 'ksBearerToken').then(res => {
          err.config.headers['Authorization'] = 'Bearer ' + res;
          // error.config.baseURL = undefined;
          return axios.request(err.config);
        });
        // else if bearer token refresh bearer token
      } else if (bearerToken) {
        return auth.refresh(bearerToken, 'bearerToken').then(res => {
          err.config.headers['Authorization'] = 'Bearer ' + res;
          // error.config.baseURL = undefined;
          return axios.request(err.config);
        });
        //handle error
      } else if (
        !validPath &&
        !err.response.request.responseURL.includes('/auth/user')
      ) {
        console.log('Session Expired');

        const intendedRoute = window.location.pathname;
        const lastRoute = localStorage.getItem('lastRoute');

        const route =
          intendedRoute !== '/login' || '/dashboard'
            ? intendedRoute
            : lastRoute;

        router.push(`/login?routeTo=${route}`);
      } else {
        return Promise.reject(err);
      }
    }
  }
);
